const StaffMember = ({ personName, jobTitle }: { personName: string, jobTitle: string }) => {
    return <div className="p-3 m-3 br-5 rounded-lg bg-white max-w-[400px]">
        <h2 className="font-bold">{personName}</h2>
        <h3>{jobTitle}</h3>
    </div>
}

export default StaffMember;